var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-date-picker',{attrs:{"value-format":"timestamp","type":"date","placeholder":_vm.field.placeholder},on:{"change":_vm.onChange},model:{value:(_vm.date_defaultValue),callback:function ($$v) {_vm.date_defaultValue=$$v},expression:"date_defaultValue"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a5e1a48","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/solely-fields/SlsDate.vue
// module id = null
// module chunks = 